var render, staticRenderFns
import script from "./ProcessDesign.vue?vue&type=script&lang=js&"
export * from "./ProcessDesign.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=f115767c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f115767c",
  null
  
)

export default component.exports